module.exports = __webpack_public_path__ + "img/total_team.aa376114.svg";